
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import EditNoteIcon from '@mui/icons-material/EditNote'
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm'
import ArticleIcon from '@mui/icons-material/Article'
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop'
import TitleBar from '../components/uiParts/TitleBar'
import MenuIcon from '../components/uiParts/MenuIcon'
import GradeIcon from '@mui/icons-material/Grade'
import WorkHistoryIcon from '@mui/icons-material/WorkHistory'
import CloudDoneIcon from '@mui/icons-material/CloudDone'
import FolderIcon from '@mui/icons-material/Folder'
import { useAuth } from '../contexts/AuthContext'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import CloseIcon from '@mui/icons-material/Close'
import { Button} from '@mui/material'
import { addDays, format } from 'date-fns'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline'
import DateOutlinedInput from '../components/input/DateOutlinedInput'
import { usePost } from './../apis/ApiRequests'
import CustomSnackBar from '../components/alert/CustomSnackBar'
import { dateToString } from '../utils/Library'
import MonitorIcon from '@mui/icons-material/Monitor'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'

const Home = () => {
    
    const { authInfo } = useAuth()
    const navigate = useNavigate()
    const today = format(addDays(new Date(), 0), 'yyyy-MM-dd')
    
    const [ openDialogUnloadReport, setOpenDialogUnloadReport ] = useState(false)
    const [ openDialogBidReport,    setOpenDialogBidReport    ] = useState(false)
    const [ openCsvExport,          setOpenDialogCsvExport    ] = useState(false)
    const [ targetDate_1,           setTargetDate_1           ] = useState(today)
    const [ targetDate_2,           setTargetDate_2           ] = useState(today)
    const [ targetDate_3,           setTargetDate_3           ] = useState(today)
    const [ openSnackBarTrue,       setOpenSnackBarTrue       ] = useState(false)

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const facilityCode   = authInfo.facilityCode
    const facilityName   = authInfo.facilityName
    const userId         = authInfo.userId
    const userName       = authInfo.userName
    const lobinAuthority = authInfo.authority

    //===============================================
    // API
    //===============================================
	//-----------------------------------------------
    // API - setDataByBidListReport / request_Print
	//-----------------------------------------------
    const { response : setData_unloadReport_res, post : setData_unloadReport_post } = usePost()
    const setData_unloadReport = async () => {
        const targetDate = dateToString(targetDate_1)
        const postData = {
            'className'    : 'mch.models.request.Print',
            'methodName'   : 'setDataByBidListReport',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'authority'    : lobinAuthority,
            'targetDate'   : targetDate,
        }
        await setData_unloadReport_post(postData)
    }
	//-----------------------------------------------
    // API - exportBidHistory / file_transfer
	//-----------------------------------------------
    const { response : exportBidHistory_res, post : exportBidHistory_post } = usePost()
    const exportBidHistory = async () => {
        const targetDate = dateToString(targetDate_2)
        const postData = {
            'className'    : 'mch.models.file.Transfer',
            'methodName'   : 'exportBidHistory',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'targetDate'   : targetDate,
        }
        await exportBidHistory_post(postData)
    }
	//-----------------------------------------------
    // API - exportBidList / file_transfer
	//-----------------------------------------------
    const { response : exportBidList_res, post : exportBidList_post } = usePost()
    const exportBidList = async () => {
        const targetDate = dateToString(targetDate_3)
        const postData = {
            'className'    : 'mch.models.file.Transfer',
            'methodName'   : 'exportBidList',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'targetDate'   : targetDate,
        }
        await exportBidList_post(postData)
    }
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - setDataByBidListReport / request_Print
	//-----------------------------------------------
    useEffect(() => {
        if (setData_unloadReport_res) {
            handleClickSnackBarTrue()
        }
    }, [setData_unloadReport_res])
	//-----------------------------------------------
    // useEffect - exportBidHistory / file_transfer
	//-----------------------------------------------
    useEffect(() => {
        if (exportBidHistory_res) {
            const textData = exportBidHistory_res.text // API応答からテキストデータを抽出
    
            // テキストデータをBlobとしてダウンロード
            const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
            const textBlob = new Blob([bom, textData], { type: 'text/plain;charset=utf-8;' })
            const textUrl = URL.createObjectURL(textBlob)
            const hiddenElement = document.createElement('a')
            hiddenElement.href = textUrl
            hiddenElement.target = '_blank'
            hiddenElement.download = 'SERIINFO.csv'
            hiddenElement.click()
            
            handleClickSnackBarTrue()
        }
    }, [exportBidHistory_res])
	//-----------------------------------------------
    // useEffect - exportBidList / file_transfer
	//-----------------------------------------------
    useEffect(() => {
        if (exportBidList_res) {
            const textData = exportBidList_res.text // API応答からテキストデータを抽出
    
            // テキストデータをBlobとしてダウンロード
            const textBlob = new Blob([textData], { type: 'text/plain;charset=utf-8;' })
            const textUrl = URL.createObjectURL(textBlob)
            const hiddenElement = document.createElement('a')
            hiddenElement.href = textUrl
            hiddenElement.target = '_blank'
            hiddenElement.download = 'SERIDATA.txt'
            hiddenElement.click()
            
            handleClickSnackBarTrue()
        }
    }, [exportBidList_res])
    
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 画面遷移
	//-----------------------------------------------
    const handleClick = (url) => {
        navigate(url)
    }
	//-----------------------------------------------
    // eventHandler - 入札明細の印刷
	//-----------------------------------------------
    const handleClick_unloadReport_execute = () => {
        setData_unloadReport()
        setOpenDialogUnloadReport(false)
    }
	//-----------------------------------------------
    // eventHandler - 売上明細の印刷
	//-----------------------------------------------
    const handleClick_BidReport_execute = () => {
        exportBidHistory()
        setOpenDialogBidReport(false)
    }
	//-----------------------------------------------
    // eventHandler - CSVダウンロード
	//-----------------------------------------------
    const handleClick_csvDownload_execute = () => {
        exportBidList()
        handleClick_dialogCsvExort_close(false)
    }
	//-----------------------------------------------
    // eventHandler - ダイアログを非表示
	//-----------------------------------------------
    const handleClick_dialogUnloadReport_close = () => {
        setOpenDialogUnloadReport(false)
    }
	//-----------------------------------------------
    // eventHandler - ダイアログを非表示
	//-----------------------------------------------
    const handleClick_dialogBidReport_close = () => {
        setOpenDialogBidReport(false)
    }
	//-----------------------------------------------
    // eventHandler - ダイアログを非表示
	//-----------------------------------------------
    const handleClick_dialogCsvExort_close = () => {
        setOpenDialogCsvExport(false)
    }
	//===============================================
	// UI Message
	//===============================================
	// スナックバー(正常)を表示
    const handleClickSnackBarTrue = () => { setOpenSnackBarTrue(true) }
	// スナックバー(正常)を閉じる
    const handleCloseSnackBarTrue = (event, reason) => {
        if (reason === 'clickaway') { return } setOpenSnackBarTrue(false)
    }
    //===============================================
    // Css
    //===============================================
    const dialog_button_close = { 
        fontSize: '16px', height:'40px', width:'460px', color:'#fff', backgroundColor:'#808080'
    }
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
        <Header loginInfo="on" backButton="off" backPage="/" />
            <div className='menu' style={{paddingTop:'2px', paddingLeft:'10px', paddingRight:'10px', paddingBottom:'10px'}}>
                { lobinAuthority != 3 ? 
                <div>
                    <TitleBar title="入札メニュー" />
                    {/*
                    <MenuIcon header="Bid Menu" title="水揚情報"  onClick={() => handleClick('/UnloadList')}>
                        <GradeIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    */}
                    <MenuIcon header="Bid Menu" title="入札明細" onClick={() => handleClick('/bidList')}>
                        <EditNoteIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Bid Menu" title="入札管理"  onClick={() => handleClick('/bidGroup')}>
                        <AccessAlarmIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Bid Menu" title="サイネージ"  onClick={() => handleClick('/signageMenu')}>
                        <MonitorIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                : <>
                    <TitleBar title="一般ユーザメニュー" />
                    {/*
                    <MenuIcon header="Bid Menu" title="水揚情報"  onClick={() => handleClick('/UnloadList')}>
                        <GradeIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    */}
                    <MenuIcon header="Bid Menu" title="入札情報"  onClick={() => handleClick('/bidGroup')}>
                        <AccessAlarmIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    {/*
                    <MenuIcon header="Bid Menu" title="入札履歴"  onClick={() => handleClick('/bidHistory')}>
                        <WorkHistoryIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    */}
                </>
                }
                { lobinAuthority != 3 ? 
                <div>
                    <TitleBar title="事務所メニュー" />
                    <MenuIcon header="Office Menu" title="データ補正"  onClick={() => handleClick('/dataInput')}>
                        <ArticleIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Office Menu" title="入札明細印刷"  onClick={() => setOpenDialogUnloadReport(true)}>
                        <LocalPrintshopIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Office Menu" title="入札ふだ管理"  onClick={() => setOpenDialogBidReport(true)}>
                        <LocalOfferIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                : <></>
                }
                { lobinAuthority == 1 ? 
                <div>
                    <TitleBar title="管理メニュー" />
                    <MenuIcon header="Management Menu" title="販売管理CSV作成"  onClick={() => setOpenDialogCsvExport(true)}>
                        <CloudDoneIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Management Menu" title="システムマスタ"  onClick={() => handleClick('/systemMastaMenu')}>
                        <FolderIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                    <MenuIcon header="Management Menu" title="入札マスタ"  onClick={() => handleClick('/bidMastaMenu')}>
                        <FolderIcon style={{fontSize: '4rem', color: '#305496'}} />
                    </MenuIcon>
                </div>
                : <></>
                }
                <div className='unloadReport_dialog'>
                    <Dialog open={ openDialogUnloadReport } onClose={ handleClick_dialogUnloadReport_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="入札明細印刷" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'auto'}}>
                            <div style={{backgroundColor:'#efefef', padding:'10px'}}>
                                <div style={{display:'flex', marginRight:'10px',marginTop:'15px'}}>
                                    <div>
                                        <DateOutlinedInput 
                                            id       = "unloadReport_targetDate" 
                                            label    = "対象日" 
                                            value    = { targetDate_1 }
                                            onChange = { (e) => setTargetDate_1(e.target.value) }
                                        />
                                    </div>
                                    <div style={{marginLeft:'20px'}}>
                                        <Button
                                            color     = "secondary"
                                            size      = "large"
                                            variant   = "contained"
                                            sx        = {{marginLeft:'10px', color:'#fff', width:'250px'}}
                                            onClick   = { () => handleClick_unloadReport_execute() }
                                            startIcon = {<LocalPrintshopIcon />}
                                        >{'印　刷'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div style={{marginTop:'20px'}}>
                                <Button
                                    color     = "tertiary"
                                    size      = "large"
                                    variant   = "contained"
                                    sx        = { dialog_button_close }
                                    onClick   = {() => handleClick_dialogUnloadReport_close()}
                                    startIcon = {<CloseIcon />}
                                >{'閉じる'}
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>
                </div>
                <div className='bidReport_dialog'>
                    <Dialog open={ openDialogBidReport } onClose={ handleClick_dialogBidReport_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="入札ふだ出力" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'auto'}}>
                            <div style={{backgroundColor:'#efefef', padding:'10px'}}>
                                <div style={{display:'flex', marginRight:'10px',marginTop:'15px'}}>
                                    <div>
                                        <DateOutlinedInput 
                                            id       = "salesReport_date" 
                                            label    = "対象日" 
                                            value    = { targetDate_2 } 
                                            onChange = { (e) => setTargetDate_2(e.target.value) }
                                        />
                                    </div>
                                    <div style={{marginLeft:'20px'}}>
                                        <Button
                                            color     = "secondary"
                                            size      = "large"
                                            variant   = "contained"
                                            sx        = {{marginLeft:'10px', color:'#fff', width:'250px'}}
                                            onClick   = { () => handleClick_BidReport_execute() }
                                            startIcon = {<DownloadForOfflineIcon />}
                                        >{'ダウンロード'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div style={{marginTop:'20px'}}>
                                <Button
                                    color     = "tertiary"
                                    size      = "large"
                                    variant   = "contained"
                                    sx        = { dialog_button_close }
                                    onClick   = {() => handleClick_dialogBidReport_close()}
                                    startIcon = {<CloseIcon />}
                                >{'閉じる'}
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>
                </div>
                <div className='csvExport_dialog'>
                    <Dialog open={ openCsvExport } onClose={ handleClick_dialogCsvExort_close } maxWidth='lg' >
                        <DialogTitle>
                            <TitleBar title="販売管理CSV作成" />
                        </DialogTitle>
                        <DialogContent style={{border:'none'}} sx = {{width:'auto'}}>
                            <div style={{backgroundColor:'#efefef', padding:'10px'}}>
                                <div style={{display:'flex', marginRight:'10px',marginTop:'15px'}}>
                                    <div>
                                        <DateOutlinedInput 
                                            id       = "csvExport_dialog" 
                                            label    = "対象日" 
                                            value    = { targetDate_3 } 
                                            onChange = { (e) => setTargetDate_3(e.target.value) }
                                        />
                                    </div>
                                    <div style={{marginLeft:'20px'}}>
                                        <Button
                                            color     = "secondary"
                                            size      = "large"
                                            variant   = "contained"
                                            sx        = {{marginLeft:'10px', color:'#fff', width:'250px'}}
                                            onClick   = { () => handleClick_csvDownload_execute() }
                                            startIcon = {<DownloadForOfflineIcon />}
                                        >{'ダウンロード'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div style={{marginTop:'20px',marginLeft:'0px'}}>
                                <Button
                                    color     = "tertiary"
                                    size      = "large"
                                    variant   = "contained"
                                    sx        = { dialog_button_close }
                                    onClick   = {() => handleClick_dialogCsvExort_close()}
                                    startIcon = {<CloseIcon />}
                                >{'閉じる'}
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>
                </div>
                <CustomSnackBar
                    open            = {openSnackBarTrue}
                    onClose         = {() => handleCloseSnackBarTrue()}
                    severity        = "success"
                    backgroundColor = "#2e8b57"
                    message         = "実行しました"
                />
            </div>
        </>
    )
}
export default Home

  
